import Vue from 'vue'

/**
 * 利用 Vue 将一个对象 reactive 化
 */
export default function (data) {
  const Instance = {}

  Vue.util.defineReactive(Instance, 'reactive', data)

  return Instance.reactive
}

export const makeReactive = function (data) {
  const keys = Object.keys(data)
  for (let i = 0; i < keys.length; i++) {
    const prop = keys[i]
    Object.defineProperty(data, prop, {
      enumerable: true,
      get: () => data[prop],
      set: (val) => {
        data[prop] = val
      },
    })
  }
}
